import React, { useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box, Button } from '@mui/material'
import StatusCustom from '../../../../components/status/statusCustom'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { approve_or_reject_payment, ELibraryManagementApi, update_number_book } from '../../../../api/e-library/e_library_management'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import PaymentCart from '../../elibrary-system/element/PaymentCart'
import moment from 'moment'
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal'
import { routeName } from '../../../../routes/routeName'
import { RootState } from '../../../../store/store'
import { LIBRARY_DETAIL_TYPE, LIBRARY_PAYMENT_STATUS } from '../../enum/elibrary_enum'
import ModalCustom from '../../../../components/modal/modalCustomCms'
import StateComponents from '../../../../components/state-component/StateComponents'
import { produce } from 'immer'

type Props = {
    view: boolean
}

const ManageOrdersDetail: React.FC<Props> = ({ view }: Props) => {
    const location = useLocation();
    const pathname = location.pathname;
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const base_api = useSelector((state: RootState) => state.api.image_api);



    const [detail, setDetail] = useState<any>(null);
    const [file_path, set_file_path] = useState<string>("");

    const [show_modal, set_show_modal] = useState<boolean>(false);
    const [library_list_item_number, set_library_list_item_number] = useState<any[]>([]);


    const handleCloseModal = () => {
        set_show_modal(false);
        set_library_list_item_number((prev) => prev.map((x) => ({ ...x, value: null })));
    }

    const handleChangeListItemNumber = (field: string, index: number, value: any) => {
        set_library_list_item_number((prev) =>
            produce(prev, (draft) => {
                draft[index][field] = value;
            })
        );
    };

    const handleGetDetail = async (id_library_payment_head: number) => {
        dispatch(setLoading());
        await ELibraryManagementApi.findOnePayment(id_library_payment_head).then(async (res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                const library_pay_files: any[] = response?.library_pay_files || [];
                const library_list_item_number_data: any[] = response?.library_list_item_number || [];
                if (library_list_item_number_data?.length > 0) {
                    set_library_list_item_number(await Promise.all(library_list_item_number_data?.map(async (list) => {
                        const list_item = await handleGetListNumberItem(list?.id_library_head, list?.id_library_detail);
                        const findOne = list_item?.find((x) => x.id_library_detail == list?.id_library_detail);
                        return {
                            ...list,
                            list_item: list_item,
                            value: findOne ? {
                                library_detail_number: findOne?.library_detail_number,
                                id_library_payment_detail: findOne?.id_library_payment_detail
                            } : null
                        }
                    })))
                }
                if (library_pay_files?.length > 0) {
                    const file_data = library_pay_files[0];
                    set_file_path(`${base_api}/${file_data?.file_path}${file_data?.file_name}`)
                }
                setDetail(response);
                // console.log(response, 'response')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleConfirmOrder = (id_library_payment_head: number, library_payment_head_status: string, reject?: boolean) => {
        if (reject) {
            alertActive("ดำเนินการยกเลิกการชำระ", "ท่านต้องการยกเลิกการชำระ ใช่หรือไม่", undefined, undefined, async () => {
                const body: approve_or_reject_payment = {
                    id_library_payment_head: id_library_payment_head,
                    library_payment_head_status: library_payment_head_status
                }
                dispatch(setLoading());
                await ELibraryManagementApi.approveOrReject(body).then((res) => {
                    if (res.status < 300) {
                        alertSuccess("ดำเนินการยกเลิกการชำระ", "ดำเนินการยกเลิกการชำระ เรียบร้อยแล้ว");
                        navigate(routeName.e_library.manage_orders);
                    }
                }).catch((err) => {
                    console.log(err)
                    alertError("ดำเนินการยกเลิกการชำระ", "ดำเนินการยกเลิกการชำระ ไม่สำเร็จลองใหม่อีกครั้ง")
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            })
        } else {
            alertActive("ยืนยันการชำระเงิน", "ท่านต้องการยืนยันการชำระเงิน ใช่หรือไม่", undefined, undefined, async () => {
                const body: approve_or_reject_payment = {
                    id_library_payment_head: id_library_payment_head,
                    library_payment_head_status: library_payment_head_status
                }
                dispatch(setLoading());
                await ELibraryManagementApi.approveOrReject(body).then((res) => {
                    if (res.status < 300) {
                        alertSuccess("ยืนยันการชำระเงิน", "ยืนยันการชำระเงิน เรียบร้อยแล้ว");
                        navigate(routeName.e_library.manage_orders);
                    }
                }).catch((err) => {
                    console.log(err)
                    alertError("ยืนยันการชำระเงิน", "ยืนยันการชำระเงิน ไม่สำเร็จลองใหม่อีกครั้ง")
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            })
        }
    }

    const handleGetListNumberItem = async (id_library_head: number, id_library_details_in: string): Promise<any[]> => {
        return await ELibraryManagementApi.listNumberItem(id_library_head, LIBRARY_DETAIL_TYPE.SALES, id_library_details_in).then((res) => {
            if (res.status < 300) {
                return res.data?.data || [];
                // console.log(response, 'response')
            } else {
                return []
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const handleUpdateNumberBook = async () => {
        const body: update_number_book[] = library_list_item_number?.length > 0 ? library_list_item_number?.map((list) => {
            return {
                id_library_detail_new: list?.value?.id_library_detail || null,
                id_library_detail_old: list?.id_library_detail || null,
                id_library_history: list?.id_library_history || null,
                id_library_payment_detail: list?.id_library_payment_detail || null
            }
        }) : []
        dispatch(setLoading());
        await ELibraryManagementApi.updateNumberBook(body).then((res) => {
            if (res.status < 300) {
                handleCloseModal();
                navigate(routeName.e_library.manage_orders);
                alertSuccess("ยืนยันการรับหนังสือ", "ยืนยันการรับหนังสือ เรียบร้อยแล้ว");
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }



    useEffect(() => {
        if (id && !isNaN(+id)) {
            handleGetDetail(+id);
        }
    }, [])

    return (
        <ContainerLayout
            title='รายละเอียดการสั่งซื้อ'
            sub_title_custom={
                <Box className="flex justify-start items-center w-full">
                    <StatusCustom
                        text={detail?.library_payment_head_status || ""}
                        type={detail?.library_payment_head_status || ""}
                        disableMaxWidth
                        sx={{ maxWidth: "fit-content", px: 2 }}
                    />
                </Box>
            }
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "จัดการข้อมูล E-Library",
                            name: "จัดการข้อมูล E-Library",
                            pathName: "",
                            disabled_match: true
                        },
                        {
                            key: "จัดการรายการสั่งซื้อ",
                            name: "จัดการรายการสั่งซื้อ",
                            pathName: pathname
                        },
                    ]}
                />
            }
            buttonContent={
                <Box className="flex justify-end items-center gap-4">
                    {!view && (
                        <>
                            <Button onClick={() => window.history.length > 0 ? navigate(-1) : navigate(routeName.e_library.manage_orders)} sx={{ borderRadius: "8px" }} variant='outlined'>ย้อนกลับ</Button>
                            {LIBRARY_PAYMENT_STATUS.WAITING_APPROVE_PAYMENT === detail?.library_payment_head_status ? (
                                <>
                                    <Button
                                        onClick={() => detail?.id_library_payment_head ? handleConfirmOrder(detail?.id_library_payment_head, LIBRARY_PAYMENT_STATUS.REJECT_PAYMENT, true) : undefined}
                                        startIcon={<CheckBoxOutlinedIcon />}
                                        color='error'
                                        variant='contained'>ชำระไม่สำเร็จ
                                    </Button>
                                    <Button
                                        onClick={() => detail?.id_library_payment_head ? handleConfirmOrder(detail?.id_library_payment_head, LIBRARY_PAYMENT_STATUS.APPROVE_PAYMENT) : undefined}
                                        startIcon={<CheckBoxOutlinedIcon />}
                                        color='success'
                                        variant='contained'>ยืนยันการชำระเงิน
                                    </Button>
                                </>
                            ) : LIBRARY_PAYMENT_STATUS.APPROVE_PAYMENT === detail?.library_payment_head_status ? (
                                <Button
                                    onClick={() => set_show_modal(true)}
                                    startIcon={<CheckBoxOutlinedIcon />}
                                    color='success'
                                    variant='contained'>ยืนยันการรับหนังสือ
                                </Button>
                            ) : <></>}
                        </>
                    )}

                </Box>
            }
            content={
                <Box>
                    <PaymentCart
                        bill_no={detail?.order_number || ""}
                        bill_date={detail?.created_date || null}
                        customer_name={""}
                        payment_file={null}
                        file_path={file_path}
                        onFileChange={() => { }}
                        pay_date={detail?.exp_date_payment || null}
                        payment_amount={detail?.total_amount || ""}
                        onPaymentAmountChange={(p) => () => { }}
                        onPaymentDateChange={(p) => () => { }}
                        onPaymentTimeChange={(p) => () => { }}
                        payment_date={detail?.library_payment_head_date}
                        payment_time={detail?.library_payment_head_date ? moment(detail?.library_payment_head_date).format("HH:mm") : ""}
                        payment_list_data={detail?.library_pay_details?.map((list: any) => {
                            return {
                                file_name: list?.file_name,
                                file_path: list?.file_path,
                                id_library_head: list?.id_library_head,
                                library_author_by: list?.library_author_by,
                                library_head_name: list?.library_head_name,
                                library_type_name: "",
                                price: list?.price_amount,
                                qty: list?.qty
                            }
                        })}

                        payment_icon_url={""}
                        payment_name={""}
                        payment_name_en={""}
                        payment_no={""}
                        payment_type={""}
                        is_management_borrow
                    />

                    {show_modal && (
                        <ModalCustom
                            handleClose={handleCloseModal}
                            onClick={handleUpdateNumberBook}
                            open
                            title='ยืนยันการรับหนังสือ'
                            subTitle='กรุณาระบุข้อมูลให้ครบถ้วนก่อนทำการยืนยัน'
                            disabledSubmitButton={!library_list_item_number?.every((x) => x.value)}
                            scrollBody
                            form={
                                <Box className="w-full">

                                    <StateComponents
                                        otherProps={{ spacing: 2 }}
                                        typeProps={library_list_item_number?.map((list, i) => {
                                            return {
                                                seq: i + 1,
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                type: "AUTO-COMPLETE",
                                                fieldProps: {
                                                    heading: `รายการที่ ${i + 1} ชื่อหนังสือ : ${list?.library_head_name || ""}`,
                                                    getOptionLabel: (op) => op?.library_detail_number || "",
                                                    labelId: "dada",
                                                    onChange: (_, val) => {
                                                        if (
                                                            library_list_item_number?.some(
                                                                (x) => (x?.value?.id_library_detail ?? x?.id_library_detail) === val?.id_library_detail
                                                            )
                                                        ) {
                                                            return alertError("เลขเรียกหนังสือซ้ำกัน ไม่สามารถเลือกได้!");
                                                        }
                                                        handleChangeListItemNumber('value', i, val ?? null);
                                                    },
                                                    placeholder: "ระบุเลขหนังสือ",
                                                    options: list?.list_item || [],
                                                    value: list?.value || null
                                                }
                                            }
                                        }
                                        )}
                                    />
                                </Box>
                            }
                        />
                    )}
                </Box>
            }
        />
    )
}

export default ManageOrdersDetail